module.exports = __webpack_public_path__ + "static/media/fraisent.5c9fc616.JPG";